import { SaleModel } from '@shared/app/scripts/classes/sale-model';

export class PosState {
  /**
   * When is in return mode, contains the reference to the original transction
   */
  returnTransaction: SaleModel;

  constructor() {
    this.returnTransaction = null;
  }
}

/*
 * Service posState – keeps values related to the current state of the POS.
 */
angular.module('posApp').factory('posState', () => {
  return new PosState();
});
